import React from 'react';

export const PatternRight = ({ viewBox, fill }) => (
	<svg
		width="153.86"
		height="123"
		viewBox={viewBox}
		className="finance__pattern-right right-0">
		<g>
			<path
				d="M37.54,68.51a1.69,1.69,0,0,1,.19-.52h0A40,40,0,0,1,57.85,50.32a39.34,39.34,0,0,1,26.31-1,1.92,1.92,0,0,1,1.23,2.48l-3.58,10A1.9,1.9,0,0,1,79.49,63a25.25,25.25,0,0,0-15.52.5A25.66,25.66,0,0,0,51.52,73a1.27,1.27,0,0,1-.13.19c-.18.26-.85,1.16-1.42,1.27a1.79,1.79,0,0,1-.94-.08L38.76,70.65A1.89,1.89,0,0,1,37.54,68.51Z"
				fill={fill}
			/>
			<path
				d="M54,30.22a1.42,1.42,0,0,1-.51.18h0a39.08,39.08,0,0,1-26-4.47A39.78,39.78,0,0,1,10.14,6.18a1.91,1.91,0,0,1,1.11-2.52L21.11.11a1.86,1.86,0,0,1,2.35,1A25.53,25.53,0,0,0,33.6,12.89a25.16,25.16,0,0,0,15.06,3.64l.22,0a3.29,3.29,0,0,1,1.86.3,1.87,1.87,0,0,1,.53.78l3.62,10.33A1.88,1.88,0,0,1,54,30.22Z"
				fill={fill}
			/>
			<path
				d="M135.54,165a1.73,1.73,0,0,1-.16-.52h0a38.77,38.77,0,0,1,5.43-25.77,39.87,39.87,0,0,1,20.42-16.57,1.92,1.92,0,0,1,2.49,1.19l3.19,9.94a1.87,1.87,0,0,1-1.14,2.31,25.68,25.68,0,0,0-12.12,9.68,25,25,0,0,0-4.19,14.87v.23a3,3,0,0,1-.37,1.83,1.79,1.79,0,0,1-.8.5l-10.47,3.24A1.9,1.9,0,0,1,135.54,165Z"
				fill={fill}
			/>
			<path
				d="M44.54,136a1.73,1.73,0,0,1-.16-.52h0a38.75,38.75,0,0,1,5.43-25.77A39.87,39.87,0,0,1,70.23,93.12a1.92,1.92,0,0,1,2.49,1.19l3.19,9.94a1.87,1.87,0,0,1-1.14,2.31,25.68,25.68,0,0,0-12.12,9.68,25,25,0,0,0-4.19,14.87v.23a3,3,0,0,1-.37,1.83,1.79,1.79,0,0,1-.8.5l-10.47,3.24A1.9,1.9,0,0,1,44.54,136Z"
				fill={fill}
			/>
			<path
				d="M62.54,38a1.76,1.76,0,0,1-.16-.51h0a38.75,38.75,0,0,1,5.43-25.77A39.87,39.87,0,0,1,88.23-4.88a1.92,1.92,0,0,1,2.49,1.19l3.19,9.94a1.87,1.87,0,0,1-1.14,2.31,25.68,25.68,0,0,0-12.12,9.68,25,25,0,0,0-4.19,14.87v.22a3.07,3.07,0,0,1-.37,1.84,1.79,1.79,0,0,1-.8.5L64.82,38.91A1.9,1.9,0,0,1,62.54,38Z"
				fill={fill}
			/>
			<path
				d="M119.08,140.46a1.61,1.61,0,0,1-.53,0h0a39.75,39.75,0,0,1-24.15-10.82,39.14,39.14,0,0,1-11.87-23.16,1.88,1.88,0,0,1,1.71-2.12l10.45-.88a1.88,1.88,0,0,1,2,1.59,25.1,25.1,0,0,0,6.89,13.72,25.61,25.61,0,0,0,13.7,7.25l.23.05a3.17,3.17,0,0,1,1.72.75,1.77,1.77,0,0,1,.32.88l.92,10.73A1.86,1.86,0,0,1,119.08,140.46Z"
				fill={fill}
			/>
			<path
				d="M166.9,106a1.28,1.28,0,0,1-.25.43h0A36.76,36.76,0,0,1,144,118.53a45.3,45.3,0,0,1-26.87-4.45,1.86,1.86,0,0,1-.94-2.53l4.87-8.47a1.9,1.9,0,0,1,2.5-.61,29.15,29.15,0,0,0,15.84,2.74A24.2,24.2,0,0,0,153.24,99l.16-.15c.22-.2,1-.89,1.6-.87a2.07,2.07,0,0,1,.95.27l10,5.54A1.86,1.86,0,0,1,166.9,106Z"
				fill={fill}
			/>
			<path
				d="M121,86.82a1.65,1.65,0,0,1-.42.34h0a41.13,41.13,0,0,1-26.25,4.91A40.32,40.32,0,0,1,71,80.18a1.79,1.79,0,0,1,.17-2.65l8.09-6.6a2,2,0,0,1,2.6.14A25.85,25.85,0,0,0,95.6,78.18a26.45,26.45,0,0,0,15.54-1.89l.21-.09a3.34,3.34,0,0,1,1.86-.36,1.85,1.85,0,0,1,.78.52L121,84.45A1.76,1.76,0,0,1,121,86.82Z"
				fill={fill}
			/>
			<path
				d="M159.66,35.89a1.58,1.58,0,0,1,.46-.27h0A38.55,38.55,0,0,1,186.2,35a39,39,0,0,1,20.49,15.81,1.89,1.89,0,0,1-.6,2.65l-8.89,5.33a1.86,1.86,0,0,1-2.48-.56,24.93,24.93,0,0,0-27.29-10.06l-.21.06a3.2,3.2,0,0,1-1.86.06,1.79,1.79,0,0,1-.66-.65l-5.44-9.31A1.87,1.87,0,0,1,159.66,35.89Z"
				fill={fill}
			/>
			<path
				d="M.66,78.89a1.58,1.58,0,0,1,.46-.27h0A38.55,38.55,0,0,1,27.2,78,39,39,0,0,1,47.7,93.76a1.9,1.9,0,0,1-.61,2.65l-8.89,5.33a1.85,1.85,0,0,1-2.48-.56A24.93,24.93,0,0,0,8.43,91.12l-.21.06a3.2,3.2,0,0,1-1.86.06,1.79,1.79,0,0,1-.66-.65L.26,81.28A1.87,1.87,0,0,1,.66,78.89Z"
				fill={fill}
			/>
			<path
				d="M134.06,43.63a1.69,1.69,0,0,1-.06-.54h0a40.92,40.92,0,0,1,9.84-25A39,39,0,0,1,166.5,5a1.89,1.89,0,0,1,2.18,1.65l1.3,10.6a1.9,1.9,0,0,1-1.5,2.12A25,25,0,0,0,155.05,27a26.28,26.28,0,0,0-6.7,14.23,1.6,1.6,0,0,1,0,.23,3.36,3.36,0,0,1-.68,1.79,1.78,1.78,0,0,1-.87.36L136.09,45A1.84,1.84,0,0,1,134.06,43.63Z"
				fill={fill}
			/>
			<path
				d="M125.5-22.59a1.42,1.42,0,0,1,.34.4h0a41.06,41.06,0,0,1,5.95,25.88A40.39,40.39,0,0,1,121,27.44a1.78,1.78,0,0,1-2.64-.05l-6.86-7.76a1.94,1.94,0,0,1,0-2.59,25.93,25.93,0,0,0,6.48-14,26.46,26.46,0,0,0-2.51-15.37c0-.07-.07-.13-.1-.2a3.39,3.39,0,0,1-.44-1.84,1.88,1.88,0,0,1,.49-.79l7.71-7.37A1.75,1.75,0,0,1,125.5-22.59Z"
				fill={fill}
			/>
			<path
				d="M86.75,28.61a1.77,1.77,0,0,1,.54-.1h0a40.51,40.51,0,0,1,25.62,8.39,40.05,40.05,0,0,1,14.54,22.21,1.92,1.92,0,0,1-1.51,2.33l-10.48,2a1.91,1.91,0,0,1-2.22-1.39,25.66,25.66,0,0,0-8.47-13.17A26,26,0,0,0,90.11,43l-.23,0a3.36,3.36,0,0,1-1.82-.59,1.71,1.71,0,0,1-.42-.85l-2.1-10.79A1.88,1.88,0,0,1,86.75,28.61Z"
				fill={fill}
			/>
			<path
				d="M160.79,53.16a1.55,1.55,0,0,1,.12.54h0a40.83,40.83,0,0,1-7.09,25.82,39.08,39.08,0,0,1-21,15.4,1.86,1.86,0,0,1-2.34-1.39l-2.41-10.32a1.93,1.93,0,0,1,1.27-2.28,25,25,0,0,0,12.47-9,26.16,26.16,0,0,0,5.12-14.82c0-.08,0-.15,0-.23a3.38,3.38,0,0,1,.49-1.84,1.85,1.85,0,0,1,.81-.45l10.42-2.56A1.84,1.84,0,0,1,160.79,53.16Z"
				fill={fill}
			/>
		</g>
	</svg>
);

export default PatternRight;
